import React from 'react';
import { Col } from 'antd';
import { FullHeightRow } from '../../../components';
import GivenConsentsTable from './GivenConsentsTable';

export const GivenConsentsComponent = () => (
  <FullHeightRow gutter={[10, 10]} style={{ paddingTop: '10px' }}>
    <Col span={17}>
      <GivenConsentsTable size="small" />
    </Col>
    <Col span={7} />
  </FullHeightRow>
);
